{
  "title": "Centre de préférences",
  "disclaimer": "Ci-dessous, vous pouvez choisir à quelles fins vous souhaitez autoriser les cookies sur notre site web.",
  "alertTitle": "Cookies sur %{title}",
  "alertBigPrivacy": "En cliquant sur « Accepter tous les cookies », vous acceptez le stockage de cookies sur votre appareil pour améliorer la navigation sur le site, analyser son utilisation et contribuer à nos efforts de communication.",
  "externalLinkText": "En savoir plus à ce sujet dans notre politique de confidentialité",
  "confirm": "Valider mes préférences",
  "allow": "Accepter",
  "deny": "Interdire",
  "allowAll": "Tout accepter",
  "denyAll": "Tout désactiver",
  "alertAllowAll": "Accepter tous les cookies",
  "alertSettings": "Paramètres des cookies",
  "close": "Fermer",
  "services": {
    "mandatory": {
      "title": "Fonctionnel",
      "details": "Des cookies fonctionnels servent à faire fonctionner le site. Vous ne pouvez donc pas les refuser."
    },
    "performance": {
      "title": "Performance",
      "details": "Ces cookies nous permettent de déterminer le nombre de visites et les sources du trafic, afin de mesurer et d’améliorer les performances de notre site Web. Ils nous aident également à identifier les pages les plus / moins visitées et d’évaluer comment les visiteurs naviguent sur le site Web. Toutes les informations collectées par ces cookies sont agrégées et donc anonymisées. Si vous n'acceptez pas ces cookies, nous ne serons pas informé de votre visite sur notre site."
    },
    "features": {
      "title": "Fonctionnalité",
      "details": "Ces cookies permettent d’améliorer et de personnaliser les fonctionnalités du site Web. Ils peuvent être activés par nos équipes, ou par des tiers dont les services sont utilisés sur les pages de notre site Web. Si vous n'acceptez pas ces cookies, une partie ou la totalité de ces services risquent de ne pas fonctionner correctement."
    },
    "ads": {
      "title": "Marketing",
      "details": "Ces cookies nous permettent d’utiliser votre comportement de navigation sur notre site à nos propres fins de marketing. Grâce à ces cookies, vous verrez donc des publicités pour nos produits et services sur d'autres sites Web et applications au sein et en dehors de notre site internet."
    }
  }
}
